import React from 'react';
import './auth.css'
import CustomModal from '../utils_components/modals/CustomModal';
import Login from './Login';
import Register from './Register';
import {IoMdContact} from 'react-icons/io'
import { useDispatch, useSelector } from 'react-redux';
import { setShowAuthModal } from '../../redux/reducers/navigation';

const Auth = () => {
    const dispatch = useDispatch()

    const showModal = useSelector(state => state.navigation.showAuthModal)

    const [hasAccount,setHasAccount] = React.useState(true)
    
    const setShowModal = (value) => {
        dispatch(setShowAuthModal(value))
    }

    return (
        <CustomModal
            title={hasAccount?'Connexion':'inscription'} 
            showModal={showModal} 
            setShowModal={setShowModal}
            icon = {<IoMdContact color='#DDBB87' size={25} className='me-2' />}>
                {hasAccount?
                    <Login setHasAccount={setHasAccount} setShowModal = {setShowModal}/>
                    :
                    <Register setHasAccount={setHasAccount} setShowModal = {setShowModal}/>
                }
        </CustomModal>
    );
};

export default Auth;